exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container-fluid {\n  background-color: white; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src14910448/src/src/app/components/promociones/quantum/detail-promotion/detail-promotion.component.scss
// module id = ../../../../../src/app/components/promociones/quantum/detail-promotion/detail-promotion.component.scss
// module chunks = main